import moment from "moment";
// import { useSelector } from "react-redux";
import { ORDER_TYPES } from "./Constants";
import {
  convertToMoment,
  getTimeIntervals,
  getTodayTimeIntervals,
  isRunningHoursMidnightPattern,
} from "./TimeUtils";
import { useDispatch } from "react-redux";
import { setIsTodayHoliday } from "../store/Restaurant/RestaurantActions";

export const getViewPortHeight = () => {
  const { innerHeight: height } = window;
  return height;
};

export const setLocalStorageItem = (name, val) => {
  localStorage.setItem(name, val);
};

export const getLocalStorageItem = (name) => {
  return localStorage.getItem(name);
};

export const deleteLocalStorageItem = (name) => {
  localStorage.removeItem(name);
};

export const clearEntireLocalStorage = () => {
  localStorage.clear();
};

export const modifySlotsByType = (
  hotel,
  cart,
  formValues,
  res,
  deliveryTime
) => {
  if (!res.length || !deliveryTime) {
    return [];
  }

  const currentSelectedTime = moment(deliveryTime);
  const result = [];
  const dayInfo = hotel.workingInfo.find((elem) => elem.day === moment().day());
  const hours = dayInfo?.hotelDayInfo.find(
    (elem) => elem.type === formValues.orderType
  );
  for (let i = 0; i < res.length; i++) {
    if (moment().isSame(currentSelectedTime, "date") && i === 0) {
      let typeOfOrder = "SCHEDULED";
      let properStartTime;
      hours?.running_hours.forEach((h) => {
        // Use convertToMoment so non-standard hour values like "24:30:00"
        // (backend encoding for next-day UTC) are normalized correctly.
        properStartTime = convertToMoment(h.start);
        if (
          properStartTime &&
          properStartTime.isValid() &&
          moment().isAfter(properStartTime) &&
          hotel?.openingAvailable
          // if (
          //   properStartTime &&
          //   moment().isAfter(properStartTime)
        ) {
          if (
            formValues?.orderType === ORDER_TYPES.DELIVERY &&
            hotel?.deliveryAvailable
          ) {
            typeOfOrder = "ASAP";
          } else if (
            formValues?.orderType === ORDER_TYPES.PICKUP &&
            hotel?.pickupAvailable
          ) {
            typeOfOrder = "ASAP";
          }
        }
      });

      //show buffer value instead of ASAP
      const type = cart?.checkoutDetails.orderType;
      let buffer;
      if (type === ORDER_TYPES.DELIVERY && hotel?.deliveryAvailable) {
        buffer = hotel.delivery_buffer_time;
      } else if (type === ORDER_TYPES.PICKUP && hotel?.pickupAvailable) {
        buffer = hotel.pickup_buffer_time;
      }

      if (!buffer) {
        buffer = 10;
      }

      const showASAP = buffer + "-" + (buffer + 5) + " Mins";

      const item = {
        typeOfOrder,
        value: res[i],
        // label: typeOfOrder === "ASAP" ? "ASAP" : res[i],
        label: typeOfOrder === "ASAP" ? showASAP : res[i],
      };
      result.push(item);
    } else {
      const item = {
        typeOfOrder: "SCHEDULED",
        value: res[i],
        label: res[i],
      };
      result.push(item);
    }
  }
  return result;
};

export const generateDateSlots = (hotel, orderType) => {
  const dates = [];
  let isToday = true;
  let pre_min_day = hotel?.pre_min_day === (null || 0) ? 1 : hotel?.pre_min_day;

  // Get buffer time based on order type
  const bufTime =
    orderType === ORDER_TYPES.DELIVERY
      ? hotel?.delivery_buffer_time || 0
      : hotel?.pickup_buffer_time || 0;

  for (let i = 0; i < pre_min_day; i++) {
    const validDay = hotel?.workingInfo.filter(
      (d) => d.day === moment().add(i, "day").day()
    );
    const validDayInfo = validDay[0]?.hotelDayInfo?.filter(
      (d) => d.type === orderType
    );
    let isTodayOpen = true;
    let isHoliday = false;
    if (
      isToday &&
      validDayInfo &&
      moment().add(i, "day").day() === moment().day()
    ) {
      isToday = false;
      // Check if any running hour slot can still accept orders (considering buffer time)
      let hasAvailableSlot = false;
      for (let j = 0; j < validDayInfo[0]?.running_hours?.length; j++) {
        const start = convertToMoment(validDayInfo[0]?.running_hours[j]?.start);
        const stop = convertToMoment(validDayInfo[0]?.running_hours[j]?.stop);
        const timeWithBuffer = moment().add(bufTime, "minutes");

        if (moment().isAfter(stop)) {
          // This slot has already passed
          continue;
        } else if (timeWithBuffer.isBefore(stop)) {
          // Current time + buffer is before this slot's end, so slots are available
          hasAvailableSlot = true;
          break;
        }
      }
      isTodayOpen = hasAvailableSlot;
    }

    if (hotel?.shop_hoilidays?.length > 0) {
      for (let h = 0; h < hotel?.shop_hoilidays?.length; h++) {
        if (
          moment().add(i, "day").format("YYYY-MM-DD") ===
          hotel.shop_hoilidays[h].date
        ) {
          isHoliday = true;
          // dispatch(setIsTodayHoliday(true));
          break;
        }
      }
    }

    // Midnight-store carry-over: even when day i is a holiday, include it
    // in the picker if the shop's pattern wraps midnight AND the previous
    // day is operational. The overnight tail of the previous day's shift
    // (e.g. 12am–3am) still operates on the holiday morning. Slot
    // generation will filter the holiday day to only that overnight slot.
    let isOvernightExtensionDay = false;
    if (
      isHoliday &&
      i > 0 &&
      validDayInfo &&
      validDayInfo.length > 0 &&
      validDayInfo[0]?.running_hours?.length > 0 &&
      isRunningHoursMidnightPattern(validDayInfo[0].running_hours)
    ) {
      const prevDate = moment().add(i - 1, "day");
      const prevDayInfo = hotel?.workingInfo?.find(
        (d) => d.day === prevDate.day()
      );
      const prevHours = prevDayInfo?.hotelDayInfo?.find(
        (d) => d.type === orderType
      )?.running_hours;
      const prevIsHoliday = (hotel?.shop_hoilidays || []).some(
        (h) => h?.date === prevDate.format("YYYY-MM-DD")
      );
      const prevOperational =
        !!prevDayInfo &&
        prevDayInfo.is_closed !== 1 &&
        !prevIsHoliday &&
        Array.isArray(prevHours) &&
        prevHours.length > 0;
      if (prevOperational) {
        isOvernightExtensionDay = true;
      }
    }

    if (
      !validDayInfo ||
      validDayInfo.length === 0 ||
      !isTodayOpen ||
      (isHoliday && !isOvernightExtensionDay)
    ) {
      continue;
    }

    let label = moment().add(i, "day").format("dddd");
    if (moment().add(i, "day").format("LL") === moment().format("LL")) {
      label = "Today";
    } else if (
      moment().add(i, "day").format("LL") ===
      moment().add(1, "day").format("LL")
    ) {
      label = "Tomorrow";
    }

    const date = {
      date: moment().add(i, "day").format("LL"),
      label,
    };
    dates.push(date);
  }
  //   }

  // }
  // console.log("datesssssssssss", dates);
  return dates;
};

export const getTimeIntervalSlots = (hotel, cart, formValues, deliveryTime) => {
  if (!hotel || !deliveryTime) {
    return [];
  }

  const bufTime =
    formValues.orderType === "DELIVERY"
      ? hotel.delivery_buffer_time
      : hotel.pickup_buffer_time;
  // console.log("hotel infoooo firstttttt", hotel.workingInfo)
  const dayInfo = hotel.workingInfo.find(
    (elem) => elem.day === moment(deliveryTime).day()
  );
  // console.log("hotelll", hotel)
  // console.log("day infoooo", dayInfo)
  // console.log("hotel day infoooo", dayInfo?.hotelDayInfo)
  if (dayInfo && dayInfo.hotelDayInfo) {
    const hours = dayInfo.hotelDayInfo.find(
      (elem) => elem.type === formValues.orderType
    );
    const data = hours?.running_hours.map((elem) => {
      // const options = getTodayTimeIntervals(elem.start, elem.stop, 15, bufTime);
      const options = getTimeIntervals(elem.start, elem.stop, 15, bufTime);

      return options;
    });

    const sorted = data.sort((a, b) => {
      const timeA = moment(a, "HH:mm");
      const timeB = moment(b, "HH:mm");

      return timeA.isBefore(timeB) ? -1 : 1;
    });
    const res = sorted ? sorted.reduce((prev, curr) => [...curr, ...prev]) : [];
    // const res = data ? data : [];

    const result = modifySlotsByType(
      hotel,
      cart,
      formValues,
      res,
      deliveryTime
    );
    return result;
  } else {
    return [];
  }
};
